import { useQuery } from "@tanstack/react-query";
import currentUser from "../components/UserId";

const useProfile = () => {

  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: userData = [],
  } = useQuery({
    queryKey: ["userData"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/userDetails/${currentUser}`
      );
      const profileData = await res.json();
      const data = await profileData.data;
      return data;
    },
  });
  return [userData, isLoading, isError, error, isSuccess, refetch];
};

export default useProfile;
